import React, { useMemo } from "react";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

function DropdownField({ label, value, onChange, options, disabled = false, includeEmptyOption = true }) {
  const baseId = useMemo(
    () => `select-${String(label || "").trim().replace(/\s+/g, "-").toLowerCase()}`,
    [label]
  );
  const labelId = `${baseId}-label`;
  return (
    <FormControl variant="standard" fullWidth disabled={disabled}>
      <InputLabel id={labelId} style={{ fontSize: "12px" }}>
        {label}
      </InputLabel>
      <Select
        id={baseId}
        labelId={labelId}
        value={value}
        onChange={onChange}
        label={label}
        style={{ fontSize: "12px" }}
        disabled={disabled}
        inputProps={{ "aria-label": label }}
      >
        {includeEmptyOption && (
          <MenuItem value="" style={{ fontSize: "12px" }}></MenuItem>
        )}
        {options.map((item) => (
          <MenuItem
            style={{ fontSize: "12px" }}
            key={item.Code}
            value={item.Code}
          >
            {item.Description}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default DropdownField;
